// ==================== FILE 2: src/config/ComponentRegistry.js ====================
import Banner from '../components/Banner';
import About, { FounderSection } from '../components/About';
import SpecialMenu from '../components/SpecialMenu';
import MenuSection from '../components/MenuSection';
import TeamSection from '../components/TeamSection';
import ReservationForm from '../components/ReservationForm';
import GallerySection from '../components/GallerySection';
import BlogSection from '../components/BlogSection';
import TrustBadges from '../components/TrustBadges';
import MapSection from '../components/MapSection';
import ProcessSection from '../components/ProcessSection';
import StatsSection from '../components/StatsSection';
import TestimonialSection from '../components/TestimonialSection';
import CategoryGrid from '../components/CategoryGrid';
import AnnouncementBar from '../components/AnnouncementBar';
import SweetPromoBanner from '../components/SweetPromoBanner';
import FinalCTA from '../components/FinalCTA';

export const ComponentMap = {
  Banner: Banner,
  About: About,
  SpecialMenu: SpecialMenu,
  MenuSection: MenuSection,
  TeamSection: TeamSection,
  ReservationForm: ReservationForm,
  GallerySection: GallerySection,
  BlogSection: BlogSection,
  TrustBadges: TrustBadges,
  MapSection: MapSection,
  FounderSection: FounderSection,
  ProcessSection: ProcessSection,
  StatsSection: StatsSection,
  TestimonialSection: TestimonialSection,
  CategoryGrid: CategoryGrid,
  AnnouncementBar: AnnouncementBar,
  SweetPromoBanner: SweetPromoBanner,
  FinalCTA: FinalCTA,
};